import { useState } from 'react'
import Link from 'next/link'
import clsx from 'clsx'
import styles from './Navigation.module.css'

export interface NavigationItem {
  label: string
  selected?: boolean
  path?: string
  external?: boolean
  subNavigation?: NavigationItem[]
  onClick?: () => void
}

interface NavItemProps {
  item: NavigationItem
  size?: 'normal' | 'small'
  anchor?: 'left' | 'right'
  children?: React.ReactNode
}

export const NavItem = ({ item, size = 'normal', anchor = 'left', children }: NavItemProps) => {
  const [isHovered, setIsHovered] = useState(false)

  if (item.subNavigation) {
    return (
      <div
        className={styles.navigationItem}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{ position: 'relative' }}
      >
        {children || <div>{item.label}</div>}
        <span className={clsx(styles.navigationItemArrow, isHovered && styles.navigationItemArrowOpen)} />
        <div
          className={clsx(
            styles.subNavigationContainer,
            isHovered && styles.subNavigationContainerOpen,
            anchor === 'right' && styles.subNavigationContainerAnchorRight,
          )}
        >
          <div
            className={clsx(
              styles.subNavigation,
              isHovered && styles.subNavigationOpen,
              size === 'small' && styles.subNavigationSmall,
            )}
          >
            {item.subNavigation.map((subItem, index) => (
              <div
                key={index}
                className={clsx(styles.subNavigationItem, subItem.selected && styles.subNavigationItemSelected)}
              >
                {subItem.path ? (
                  <Link href={subItem.path}>{subItem.label}</Link>
                ) : (
                  <span onClick={subItem.onClick}>{subItem.label}</span>
                )}
                {subItem.external && <ExternalLinkIcon />}
              </div>
            ))}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={clsx(styles.navigationItem, item.selected && styles.navigationItemSelceted)}>
      <Link href={item.path ?? ''}>{item.label}</Link>
      {item.external && <ExternalLinkIcon />}
    </div>
  )
}

export const ExternalLinkIcon = ({ size = 12 }: { size?: number }) => (
  <svg
    aria-hidden="true"
    focusable="false"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width={size}
    height={size}
  >
    <path
      fill="#5CCBCB"
      d="M304 41c0 10.9 4.3 21.3 12 29L362.1 116 207 271c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l155-155L442.1 196c7.7 7.7 18.1 12 29 12c22.6 0 41-18.3 41-41V40c0-22.1-17.9-40-40-40H345c-22.6 0-41 18.3-41 41zm57.9 7H464V150.1L361.9 48zM72 32C32.2 32 0 64.2 0 104V440c0 39.8 32.2 72 72 72H408c39.8 0 72-32.2 72-72V312c0-13.3-10.7-24-24-24s-24 10.7-24 24V440c0 13.3-10.7 24-24 24H72c-13.3 0-24-10.7-24-24V104c0-13.3 10.7-24 24-24H200c13.3 0 24-10.7 24-24s-10.7-24-24-24H72z"
    ></path>
  </svg>
)
